// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"adb448c9","732":"f9a6a81e","977":"ac983ec1"}[chunkId] + ".chunk.js";
};